import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/ProfileSetUp/desktop';
import Mobile from 'pages/ProfileSetUp/mobile';
import Tablet from 'pages/ProfileSetUp/tablet';

const PageLayout = () => {
    const { device } = useViewport();

    const props = {};

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return renderResponsiveLayout(device);
};

export default PageLayout;
